import React, {PropTypes} from 'react';

const {default: InputGroup} = require('module-tsl-ui-components/es5/components/input-group/Input-Group');
const {default: TextareaGroup} = require('module-tsl-ui-components/es5/components/textarea-group/Textarea-Group');

const InputWithLabel = ({input, label, type, rows, placeholder, hideLabel = false, autoFocus = false, helpText, meta: {touched, error: fieldError}}) => {
  const error = touched && fieldError ? fieldError : null;
  const field = type === 'textarea' ?
    (<TextareaGroup
      self={{groupId: input.name, error, helpText}}
      label={{text: label, hide: hideLabel}}
      textarea={Object.assign({}, input, {rows, autoFocus, placeholder})}
    />) :
    (<InputGroup
      self={{groupId: input.name, error}}
      label={{text: label, hideLabel}}
      input={Object.assign({}, input, {autoFocus, placeholder})}
    />);

  return field;
};

InputWithLabel.propTypes = {
  input: PropTypes.object.isRequired,
  label: PropTypes.string,
  type: PropTypes.string,
  rows: PropTypes.string,
  hideLabel: PropTypes.bool,
  placeholder: PropTypes.string,
  helpText: PropTypes.string,
  autoFocus: PropTypes.bool,
  meta: PropTypes.object,
};

export default InputWithLabel;
